import { useEffect } from 'react';

import { useDebounce } from './useDebounce';

/**
 * Хук для отслеживания изменения размера окна с debounce
 * @param callback - Функция, которая будет вызвана при изменении размера окна
 * @param delay - Задержка debounce в миллисекундах (по умолчанию 300ms)
 */
export const useWindowResize = (callback: () => void, delay: number = 300) => {
    const debouncedCallback = useDebounce(callback, delay);

    useEffect(() => {
        window.addEventListener('resize', debouncedCallback);

        return () => {
            window.removeEventListener('resize', debouncedCallback);
        };
    }, [debouncedCallback]);
};
